var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.497 7.581a.54.54 0 0 0-.603.487.54.54 0 0 1-.805.421.542.542 0 0 0-.746.221.539.539 0 0 1-.901.084.536.536 0 0 0-.772-.078.543.543 0 0 1-.87-.265.541.541 0 0 0-.68-.37.542.542 0 0 1-.701-.584.54.54 0 0 0-.487-.603.54.54 0 0 1-.421-.805.542.542 0 0 0-.221-.746.539.539 0 0 1-.084-.901.536.536 0 0 0 .078-.772.547.547 0 0 1 .272-.87.541.541 0 0 0 .37-.68.542.542 0 0 1 .584-.701.54.54 0 0 0 .603-.487.54.54 0 0 1 .804-.421c.266.149.603.051.746-.221a.539.539 0 0 1 .902-.084c.188.24.538.279.772.078A.54.54 0 0 1 6.2.556c.084.292.389.46.68.37a.542.542 0 0 1 .701.584.54.54 0 0 0 .487.603.54.54 0 0 1 .421.804.542.542 0 0 0 .221.746c.35.182.39.662.084.902a.536.536 0 0 0-.078.772.543.543 0 0 1-.265.869.541.541 0 0 0-.37.681.542.542 0 0 1-.584.694Z",
    fill: "#3FCE81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.5 4 6l3-3",
    stroke: "#F5F6FA",
    strokeLinecap: "round"
  })));
};

export default SvgCheckCircle;